import { useEffect, useState } from "react";
import useMediaQuery from "../../utils/useMediaQuery";
import { prepareEventPosters } from "../wall/preparePosters";
import useMasonry from "../wall/useMasonry";
import PeopleActivityCard from "../PeopleActivityCard";

export default function PeopleMasonry({ activity, onOpen, filterKey }) {
  const desktop = useMediaQuery("(min-width: 980px)");
  const tablet = useMediaQuery("(min-width: 640px)");
  const cols = desktop ? 3 : tablet ? 2 : 1;
  const [prepared, setPrepared] = useState({ source: null, items: [] });
  useEffect(() => {
    let cancelled = false;
    prepareEventPosters(activity.map((a) => a.event)).then((events) => {
      if (!cancelled)
        setPrepared({
          source: activity,
          items: activity.map((item, i) => ({
            ...item,
            event: events[i],
            id: `${item.type}-${item.event.id}-${item.actorUserId}`,
          })),
        });
    });
    return () => {
      cancelled = true;
    };
  }, [activity]);
  const items = prepared.source === activity ? prepared.items : [];
  const width = Math.max(
    250,
    (Math.min(window.innerWidth, 1280) - (tablet ? 56 : 32) - (cols - 1) * 20) /
      cols
  );
  const estimate = (item) =>
    width / (item.event.posterAspectRatio < 0.95 ? 0.8 : 16 / 9) +
    190 +
    Math.min(3, Math.ceil(item.event.title.length / (width / 10))) * 23;
  const { columns, colRef } = useMasonry(
    items,
    cols,
    estimate,
    filterKey + "|" + activity.map((a) => a.event.id + a.type).join(","),
    tablet ? 20 : 14
  );
  return (
    <div
      className="people-masonry"
      style={{ gridTemplateColumns: `repeat(${cols}, minmax(0,1fr))` }}
      aria-busy={prepared.source !== activity}
    >
      {columns.map((column, c) => (
        <div key={c} ref={colRef(c)} className="people-masonry-column">
          {column.map((item) => (
            <PeopleActivityCard key={item.id} item={item} onOpen={onOpen} />
          ))}
          {prepared.source !== activity &&
            activity
              .slice(c, c + 1)
              .map((item) => (
                <div
                  key={item.event.id}
                  className="animate-pulse bg-white"
                  style={{ height: 410 }}
                  aria-label="Loading event"
                />
              ))}
        </div>
      ))}
    </div>
  );
}
